module.exports = __webpack_public_path__ + "static/media/checkbox.fc268c39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/CarEditorPage/components/carActiveTableRow/img/checkbox.svg
// module id = 1666
// module chunks = 0